export default __webpack_public_path__ + "static/media/error-confirm-email.8fb20974.jpg";